







import {Component, Mixins} from 'vue-property-decorator';
import WebMenuComponent from '@/components/responsive/menu/WebMenuComponent.vue';
import MobileMenuComponent from '@/components/responsive/menu/MobileMenuComponent.vue';
import {ResponsiveMixin} from '@/mixins/ResponsiveMixin';
import MenuItem from '@/models/MenuItem';
import {findAll} from '@/repositories/local/MenuItemLocal';
@Component({
  components: {
    WebMenuComponent,
    MobileMenuComponent
  }
})
export default class MenuComponent extends Mixins(ResponsiveMixin) {
  menuItems: MenuItem[] = findAll();

}
